import * as React from "react";
import * as Sentry from "@sentry/react";
import { useToggle } from "react-use";
import { toast } from "react-toastify";

export const useCopyAction = () => {
  const [copied, toggleCopied] = useToggle(false);
  const timerRef = React.useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

  const executeCopy = async (copyFn: () => Promise<void>) => {
    try {
      await copyFn();
      clearTimeout(timerRef.current);
      toggleCopied(true);
      timerRef.current = setTimeout(() => toggleCopied(false), 2000);
    } catch (error) {
      Sentry.captureException(error);
      toast.error("Failed to copy to clipboard");
    }
  };

  React.useEffect(() => () => clearTimeout(timerRef.current), []);

  return { copied, executeCopy };
};
